import React, { useState, useEffect } from "react";
// import { Checkbox } from "@progress/kendo-react-inputs";
import { Grid } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
// import { get, pickBy, identity, isEmpty, reject } from "lodash";
// import CheckboxIcon from "Assets/images/new-checkbox.svg";
// import CheckboxCheckedIcon from "Assets/images/new-checkbox-select.svg";
import { process } from "@progress/kendo-data-query";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";
const idGetter = getter(DATA_ITEM_KEY);

export const CheckinDetailGrid = (props) => {
  const [dataState, setDataState] = useState({});
  // const [headerChecked, setHeaderChecked] = useState(false);
  const [gridData, setGridData] = useState(props.data);
  const [page, setPage] = useState({
    skip: 0,
    take: 10,
  });
  const createDataState = (data, dataState) => {
    const result = process(data.slice(0), {
      filter: dataState.filter,
      sort: dataState.sort,
    }).data.map((item) => {
      return {
        ...item,
        [SELECTED_FIELD]: props.selectedState[idGetter(item)],
      };
    });
    setGridData(result);
    setDataState(dataState);
  };
  const pageChange = (event) => {
    setPage(event.page);
  };
  useEffect(() => {
    if (props.data) {
      let data = props.data.map((item) => {
        return {
          ...item,
          [SELECTED_FIELD]: props.selectedState[idGetter(item)],
        };
      });
      setGridData(data);
      createDataState(data, dataState);
    }
  }, [props.data, props.selectedState]);

  const onDataStateChange = (event) => {
    props.setSort && props.setSort(event.dataState.sort);
    createDataState(props.data, event.dataState);
  };

  return (
    <Grid
      {...dataState}
      data={(gridData || [])?.slice(page.skip, page.take + page.skip)}
      dataItemKey={DATA_ITEM_KEY}
      sortable
      pageSize={5}
      sort={props.sort}
      onPageChange={pageChange}
      skip={page.skip}
      take={page.take}
      total={gridData?.length || 0}
      pageable={{
        buttonCount: 4,
        pageSizes: [10, 25, 50, 100],
      }}
      // data-testId='add'
      rowRender={props?.rowRender}
      onDataStateChange={onDataStateChange}
      onExpandChange={props.onExpandChange}
      expandField={props.expandField}
      detail={props.detail}
    >
      {props.children}
    </Grid>
  );
};

export default CheckinDetailGrid;
